// FIXED HEADER ON SCROLL UP
export function initHeaderFixed() {
	let scrollTimeOut = true,
		lastYPos = 0,
		yPos = 0,
		yPosDelta = 2,
		nav = $('.site-header'),
		navHeight = nav.outerHeight(),
		setNavClass = function () {
			scrollTimeOut = false;
			yPos = $(window).scrollTop();

			if (Math.abs(lastYPos - yPos) >= yPosDelta) {
				if (yPos > lastYPos && yPos > navHeight) {
					nav.addClass('hide-nav');
					$('.global--alert .site-header__alert').hide();

					// only set background to white when user scrolls up
					setTimeout(function () {
						// if homepage set the header background to white
						if ($('body').hasClass('home')) {
							nav.addClass('set-background');
						}
					}, 500);

				} else {
					nav.removeClass('hide-nav');
					$('.global--alert .site-header__alert').show();
				}
				lastYPos = yPos;
			}
		};

	$(window).scroll(function (e) {
		scrollTimeOut = true;
	});

	setInterval(function () {
		if (scrollTimeOut) {
			setNavClass();
		}

	}, 250);
}
